import styled from 'styled-components'

import {Spinner} from './Loading'

const Shade = styled.div`
  background-color: transparent;
  bottom: 0;
  right: 0;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  opacity: 0;

  width: 100%;
  z-index: 100;
  display: none;

  ${({hidden}) =>
    !hidden
      ? `
    display: block;
    pointer-events: auto;
    opacity: 1;
  `
      : ''}
`

export type Props = {
  hidden: boolean
}

export default (props: Props) => (
  <Shade {...props}>
    <Spinner />
  </Shade>
)
